<template>
  <div>
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="1">
          <v-btn @click="backToUsers()" icon small>
            <v-icon color="primary">mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="9">
          <h2 class="compeatfont">User : {{ selectedUser.name }}</h2>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            v-if="selectedUser.isActive == true"
            small
            rounded
            class="primary"
            @click="changeUserStatus()"
            >Deactivate</v-btn
          >
          <v-btn
            v-else
            small
            rounded
            class="primary"
            @click="changeUserStatus()"
            >Activate</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="3" lg="3">
          <v-card class="cardsradius" v-if="!loading">
            <v-card-text>
              <v-row>
                <v-col cols="12" class="text-center">
                  <v-avatar color="primary" size="70px">
                    <h2 class="white--text compeatfont">
                      {{ selectedUser.name | abbreviation }}
                    </h2>
                  </v-avatar>
                </v-col>
                <v-col cols="12">
                  <h2>Personal Info</h2>
                  <v-divider class="my-3"></v-divider>
                  <h4>Name: {{ selectedUser.name }}</h4>
                  <h4>Email: {{ selectedUser.email }}</h4>
                  <h4>Mobile: {{ selectedUser.mobile }}</h4>
                </v-col>
                <v-col cols="12">
                  <h2>Agency Info</h2>
                  <v-divider class="my-3"></v-divider>
                  <v-img
                    width="200px"
                    class="mx-auto"
                    :lazy-src="selectedUserAgency.agencyLogo"
                    :src="selectedUserAgency.agencyLogo"
                  />
                  <h4>Agency Name: {{ selectedUserAgency.agencyName }}</h4>
                  <h4>
                    User Role:
                    {{ selectedUser.userType | changeAbbreviationUserType }}
                  </h4>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-skeleton-loader v-else height="372px" class="mx-auto" type="image">
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" md="9" lg="9">
          <v-card v-if="!loading" flat>
            <v-card-text class="py-0">
              <v-tabs rounded v-model="tab" background-color="primary" dark>
                <v-tab
                  :key="0"
                  class="px-5"
                  v-if="selectedUser.userType == 'AS'"
                >
                  Stats
                </v-tab>
                <v-tab
                  v-if="
                    selectedUser.userType == 'AA' ||
                    selectedUser.userType == 'SMM' ||
                    selectedUser.userType == 'SB'
                  "
                  :key="1"
                  class="px-5"
                >
                  <p
                    class="mb-0 tabtext"
                    v-if="
                      selectedUser.userType == 'AA' ||
                      selectedUser.userType == 'SMM'
                    "
                  >
                    Agents Active Subscriptions
                  </p>
                  <p class="mb-0 tabtext" v-if="selectedUser.userType == 'SB'">
                    Clients Active Subscriptions
                  </p>
                </v-tab>
                <v-tab
                  v-if="
                    selectedUser.userType == 'AA' ||
                    selectedUser.userType == 'SMM'
                  "
                  :key="2"
                  class="px-5"
                >
                  <p class="mb-0 tabtext">Agents Cancelled Subscriptions</p>
                </v-tab>
                <v-tab
                  v-if="
                    selectedUser.userType == 'AA' ||
                    selectedUser.userType == 'SMM' ||
                    selectedUser.userType == 'AS'
                  "
                  :key="3"
                  class="px-5"
                >
                  <p class="mb-0 tabtext">Demo Reports</p>
                </v-tab>
                <v-tabs-items v-model="tab">
                  <v-tab-item :key="0" v-if="selectedUser.userType == 'AS'">
                    <v-card flat>
                      <v-card-text> Stats </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item
                    :key="1"
                    v-if="
                      selectedUser.userType == 'AA' ||
                      selectedUser.userType == 'SMM'
                    "
                  >
                    <v-card flat>
                      <v-card-text>
                        <v-data-table
                          :headers="headers"
                          :items="activeSubscriptions"
                          :search="search"
                          :items-per-page="10"
                          :loading="tableLoading"
                          loading-text="Loading... Please wait"
                        >
                          <template v-slot:[`item.package`]="{ item }">
                            {{ item.package.currentPackage }}
                          </template>
                          <template v-slot:[`item.isActive`]="{ item }">
                            <v-chip class="ma-2" color="success">
                              Active
                            </v-chip>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="viewSubscription(item)"
                              icon
                              color="primary"
                              ><v-icon>mdi-eye</v-icon></v-btn
                            >
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item
                    v-if="
                      selectedUser.userType == 'AA' ||
                      selectedUser.userType == 'SMM'
                    "
                    :key="2"
                  >
                    <v-card flat>
                      <v-card-text>
                        <v-data-table
                          :headers="headers"
                          :items="cancelledSubscriptions"
                          :search="search"
                          :items-per-page="10"
                          :loading="tableLoading"
                          loading-text="Loading... Please wait"
                        >
                          <template v-slot:[`item.package`]="{ item }">
                            {{ item.package.currentPackage }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="viewCancelledSubscription(item)"
                              icon
                              color="primary"
                              ><v-icon>mdi-eye</v-icon></v-btn
                            >
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item
                    v-if="
                      selectedUser.userType == 'AA' ||
                      selectedUser.userType == 'SMM' ||
                      selectedUser.userType == 'AS'
                    "
                    :key="3"
                  >
                    <v-card flat>
                      <v-card-text>
                        <v-data-table
                          :headers="demoHeaders"
                          :items="demoReports"
                          :search="search"
                          :items-per-page="10"
                          :loading="tableLoading"
                          loading-text="Loading... Please wait"
                        >
                          <template v-slot:[`item.package`]="{ item }">
                            {{ item.package.currentPackage }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="viewDemoReport(item)"
                              icon
                              color="primary"
                              ><v-icon>mdi-eye</v-icon></v-btn
                            >
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-card-text>
          </v-card>
          <v-skeleton-loader
            v-else
            height="372px"
            class="mx-auto"
            type="table-heading, table-thead, table-tbody, table-tfoot"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { firebaseApp } from "../firebaseConfig";
import {
  doc,
  getDoc,
  getDocs,
  getFirestore,
  query,
  collection,
  where,
  updateDoc,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);
import moment from "moment-timezone";
export default {
  props: ["id"],
  data: () => ({
    //loading data skeleton
    loading: false,

    // selected user array
    selectedUser: [],

    //selected user agency
    selectedUserAgency: [],

    //tab varibles
    tab: null,

    //active and cancelled subscriptions varibles and for table
    search: "",
    activeSubscriptions: [],
    cancelledSubscriptions: [],
    headers: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package", align: "center" },
      {
        text: "Date Created",
        value: "dateCreated",
        sortable: true,
        align: "center",
      },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],
    cancelledHeaders: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package", align: "center" },
      {
        text: "Date Created",
        value: "dateCancelled",
        sortable: false,
        align: "center",
      },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],
    tableLoading: false,

    //demo reports varibles
    demoReports: [],
    demoHeaders: [
      {
        text: "Client",
        value: "prospectingClientName",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Company",
        sortable: false,
        value: "packagePages[0].name",
        width: "15%",
        align: "center",
      },
      {
        text: "Email",
        sortable: false,
        value: "prospectingClientEmail",
        width: "15%",
        align: "center",
      },
      {
        text: "Date Created",
        value: "createdAt",
        sortable: false,
        width: "10%",
        align: "center",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        width: "10%",
        align: "center",
      },
    ],
  }),
  created() {
    this.loading = true;
    this.getselectedUser();
  },
  filters: {
    //abbreviates the users name
    abbreviation(fullName) {
      const words = fullName.split(" ");
      if (words.length <= 2) {
        return words.map((word) => word[0]).join("");
      } else {
        return words[0][0] + words[words.length - 1][0];
      }
    },
    //change the usertype abbreviation to the words
    changeAbbreviationUserType(userType) {
      if (userType == "SMM") {
        return "Social media Manager";
      } else if (userType == "AA") {
        return "Agency Admin";
      } else if (userType == "SB") {
        return "Subscriber";
      } else if (userType == "AS") {
        return "Agency Sales";
      }
    },
  },
  methods: {
    // get selected user
    async getselectedUser() {
      const docRef = doc(db, "users", this.id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        this.selectedUser = docSnap.data();
        console.log("this.selectedUser", this.selectedUser);
        this.getAgency();
      } else {
        this.loading = false;
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }
    },
    //get agency user belongs to
    async getAgency() {
      const docRef = doc(db, "agencies", this.selectedUser.agencyId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        this.selectedUserAgency = docSnap.data();
        this.getAgencyUserSubscriptions();
        this.loading = false;
      } else {
        this.loading = false;
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }
    },
    //get all agency user subscriptions
    async getAgencyUserSubscriptions() {
      this.tableLoading = true;
      const q = query(
        collection(db, "subscriptions"),
        where("subscriberId", "==", this.selectedUser.id)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let subscription = doc.data();

        console.log("subscription", subscription);

        if (subscription.isActive == true) {
          this.activeSubscriptions.push(subscription);
        }
      });
      this.getAgencyUserCancelledSubscriptions();
    },
    //get all agency user cancelled subscriptions
    async getAgencyUserCancelledSubscriptions() {
      const q = query(
        collection(db, "cancelledsubscriptions"),
        where("agencyUser", "==", this.selectedUser.id)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let subscription = doc.data();

        this.cancelledSubscriptions.push(subscription);
      });
      this.getAgencyUserDemoReports();
    },
    //get all agency user demo reports
    async getAgencyUserDemoReports() {
      let currentUsersDemos = [];
      const q = query(
        collection(db, "demoreports"),
        where("agencyId", "==", this.selectedUser.agencyId)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let report = doc.data();
        let createdMilliseconds = report.createdAt;
        let formatCreatedDate =
          moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
        report.createdAt = formatCreatedDate;

        if (
          report.agencyUser == this.selectedUser.id ||
          report.salesPerson == this.selectedUser.id
        ) {
          currentUsersDemos.push(report);
        }
      });
      this.demoReports = await this.sortUserArraysByDate(currentUsersDemos);
      this.tableLoading = false;
    },
    //sort by date
    sortUserArraysByDate(array) {
      array.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      return array;
    },
    // active or deactivate user
    async changeUserStatus() {
      const newValue = !this.selectedUser.isActive;

      const userRef = doc(db, "users", this.selectedUser.id);

      await updateDoc(userRef, {
        isActive: newValue,
      });

      this.getselectedUser();
    },
    // back button to all users
    backToUsers() {
      this.$router.push({
        name: "users",
      });
    },
    //View the subscription
    viewSubscription(item) {
      this.$router.push({
        name: "singleSubscription",
        params: {
          id: this.$store.state.user.agencyId,
          uid: item.uid,
        },
      });
    },
    //View the Cancelled subscription
    viewCancelledSubscription(item) {
      this.$router.push({
        name: "singleCancelledSubscription",
        params: {
          id: item.agencyId,
          uid: item.uid,
        },
      });
    },
    //View the demo report
    viewDemoReport(item) {
      this.$router.push({
        name: "demoReport",
        params: {
          reportId: item.reportId,
        },
      });
    },
  },
};
</script>

<style>
.tabtext {
  font-size: 12px;
}
</style>
